import { yupResolver } from '@hookform/resolvers/yup'
import { useTranslation } from 'react-i18next'
import * as yup from 'yup'

export const useProductTransferValidationSchema = () => {
	const { t } = useTranslation()

	const productTransferValidationSchema = yup.object({
		targetBooking: yup.object({
			value: yup.string().required(t('Booking is required'))
		})
	})

	return yupResolver(productTransferValidationSchema)
}
